package com.rainbowclubs.rainbow.data.repositories

import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.data.requests.UpdateClubRequest
import com.rainbowclubs.rainbow.domain.repositories.ClubImageUpload
import com.rainbowclubs.rainbow.domain.repositories.ClubRepository
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.request.forms.*
import io.ktor.http.*
import kotlinx.serialization.json.Json

class ClubRepositoryImpl(
    private val httpClient: HttpClient,
) : ClubRepository {
    override suspend fun getClubById(clubId: String): Result<Club> {
        return try {
            val response = httpClient.get("/club/$clubId")
            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception(response.status.description))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    override suspend fun getClubImage(imageUrl: String): Result<ByteArray> {
        return try {
            val response = httpClient.get(imageUrl)
            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception(response.status.description))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    override suspend fun updateClub(
        clubId: String,
        request: UpdateClubRequest,
        image: ClubImageUpload?,
    ): Result<Club> {
        return try {
            val response = httpClient.put("/club/$clubId") {
                setBody(
                    MultiPartFormDataContent(
                        formData {
                            append("name", request.name)
                            append("description", request.description)
                            append("membershipData", Json.encodeToString(request.membershipData))
                            image?.let {
                                append(
                                    key = "clubImage",
                                    value = it.bytes,
                                    headers = Headers.build {
                                        append(HttpHeaders.ContentType, it.contentType)
                                        append(
                                            HttpHeaders.ContentDisposition,
                                            "filename=\"${it.fileName}\"",
                                        )
                                    },
                                )
                            }
                        }
                    )
                )
            }
            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception(response.status.description))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
